module.exports = __webpack_public_path__ + "img/upgraded-fee.3fc674f2.svg";